<template>
  <div>
    <v-btn
      v-for="ruolo_id in Constants.RUOLO"
      :key="ruolo_id"
      @click.native="selectRuolo(ruolo_id)"
      :disabled="disabledRuolo(ruolo_id)"
      :style="{
        opacity: disabledRuolo(ruolo_id) ? 0.2 : 1,
      }"
      depressed
      icon
      large
    >
      <span
        class="Ruolo outline"
        :class="{
          ['Ruolo_' + ruolo_id]: true,
          selezionato: selectedRuoloClassic == ruolo_id,
        }"
        >{{ ruolo(ruolo_id) }}</span
      >
    </v-btn>
  </div>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";

export default {
  name: "select-ruoli-classic",
  components: {},
  mixins: [mixins],
  mounted() {
    console.log("--> SelectRuoliClassic ready.");
  },
  destroyed() {
    console.log("<-- SelectRuoliClassic destroyed.");
  },
  model: {
    prop: "selectedRuoloClassic",
    event: "change",
  },
  props: {
    selectedRuoloClassic: {
      type: Number, //[String, Number],
      default: 0,
    },
    ruoliAllowed: {
      type: Array,
      default: function () {
        return [
          Constants.RUOLO.P,
          Constants.RUOLO.D,
          Constants.RUOLO.C,
          Constants.RUOLO.A,
        ];
      },
    },
  },
  methods: {
    selectRuolo(ruolo) {
      // Instead of directly modifying the prop, emit the event to update the parent's v-model.
      this.$emit("change", ruolo);
    },
    disabledRuolo(ruolo) {
      return this.ruoliAllowed.indexOf(ruolo) === -1;
    },
  },
};
</script>

<style lang="scss" scoped>
span.Ruolo {
  font-size: 11px;
  width: 25px;
  height: 25px;
  box-shadow: none;
  &.selezionato {
    width: 35px;
    height: 35px;
    // box-shadow: none;
  }
}
</style>
